/* dialogs: перевод строк карточки клиента — «Диалоги по всем каналам», поиск по переписке и «Откуда клиент» (contact-dialogs.tsx, ads.ts). Ключ — русская строка как в коде. */
const d: Record<string, string> = {
  "почта": "email",
  "WhatsApp (архив Wazzup)": "WhatsApp (Wazzup archive)",
  "звонок": "call",
  "Яндекс Директ": "Yandex Direct",
  "Первое обращение: {channel}{when}": "First contact: {channel}{when}",
  "кампания «{v}»": "campaign “{v}”",
  "группа «{v}»": "ad group “{v}”",
  "объявление «{v}»": "ad “{v}”",
  "по запросу «{v}»": "search term “{v}”",
  "тип «{v}»": "medium “{v}”",
  "вариант «{v}»": "variant “{v}”",
  "сеть {v}": "network {v}",
  "клик {date}": "clicked {date}",
  "Пришёл с рекламы {platform}": "Came from {platform} advertising",
  "Пришёл с рекламы": "Came from advertising",
  "Клик по рекламе зафиксирован ({kind}) — для сверки расходов с площадкой.": "The ad click is recorded ({kind}) — to reconcile spend with the ad platform.",
  "Промокод: {v}.": "Promo code: {v}.",
  "Первый визит на сайт: {url}{when}.": "First site visit: {url}{when}.",
  "Перешёл с: {v}.": "Referred from: {v}.",
  "Источник в Zoho CRM: {v}.": "Source in Zoho CRM: {v}.",
  "В Zoho CRM источник записан как «{v}».": "In Zoho CRM the source is recorded as “{v}”.",
  "Откуда клиент": "Where the client came from",
  "из архива переписки Wazzup (Zoho CRM)": "from the Wazzup chat archive (Zoho CRM)",
  "из импорта Zoho CRM": "from the Zoho CRM import",
  "из Zoho CRM": "from Zoho CRM",
  "из переписки WhatsApp": "from a WhatsApp conversation",
  "из переписки Telegram": "from a Telegram conversation",
  "из письма": "from an email",
  "создана вручную в Hub": "created manually in Hub",
  "из файла": "from a file",
  "записи контакта в Zoho CRM": "the contact record in Zoho CRM",
  "сделки в Zoho CRM": "a deal in Zoho CRM",
  "лида в Zoho CRM": "a lead in Zoho CRM",
  "меток сайта": "website tags",
  "Рекламных меток нет: ни у контакта, ни у его сделок и лидов в Zoho CRM не записаны utm-метки, объявление или источник.": "No ad marks: neither the contact nor its deals and leads in Zoho CRM have UTM tags, an ad or a source recorded.",
  "Карточка контакта — {origin}.": "Contact card — {origin}.",
  "Метки взяты из {from}.": "The marks come from {from}.",
  "Диалоги по всем каналам": "Conversations across all channels",
  "Найти в переписке: слово или фраза": "Search the correspondence: a word or phrase",
  "Поиск по переписке": "Search correspondence",
  "мы": "us",
  "заметка": "note",
  "клиент": "client",
  "Ничего не найдено.": "Nothing found.",
  "Показаны {n} из {total} — уточните запрос.": "Showing {n} of {total} — refine the query.",
  "закрыт": "closed",
  "без сообщений": "no messages",
  "Диалогов пока нет — они появятся, когда клиент напишет или ему напишут из «Входящих».": "No conversations yet — they appear when the client writes or someone writes to them from Inbox.",
};
export default d;
